/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the comparison case-sensitive?`)
};

const es_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿La comparación distingue mayúsculas de minúsculas?`)
};

const de_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist der Vergleich groß-/kleinschreibungsabhängig?`)
};

const nl_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is de vergelijking hoofdlettergevoelig?`)
};

const fr_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La comparaison est-elle sensible à la casse ?`)
};

const it_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il confronto è sensibile alle maiuscole/minuscole?`)
};

const pt_br2_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A comparação é sensível a maiúsculas/minúsculas?`)
};

const pt_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A comparação é sensível a maiúsculas/minúsculas?`)
};

const ja_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比較は大文字・小文字を区別しますか?`)
};

const zh_venn_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较是否区分大小写？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_faq_q4", locale)
	if (locale === "en") return en_venn_faq_q4(inputs)
	if (locale === "es") return es_venn_faq_q4(inputs)
	if (locale === "de") return de_venn_faq_q4(inputs)
	if (locale === "nl") return nl_venn_faq_q4(inputs)
	if (locale === "fr") return fr_venn_faq_q4(inputs)
	if (locale === "it") return it_venn_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_venn_faq_q4(inputs)
	if (locale === "pt") return pt_venn_faq_q4(inputs)
	if (locale === "ja") return ja_venn_faq_q4(inputs)
	return zh_venn_faq_q4(inputs)
};